const memberStatus = {
  enabled: 0,
  disabled: 1,
  deleting: 2,
  deleted: 3,
  suspended: 4
}

const ordersStatus = {
  created: 0,
  processing: 1,
  success: 2,
  txnFailed: 3,
  cancelled: 4,
  release: 5,
  fullRefund: 6,
  partRefund: 7,
  transfered: 8,
  userFullRefund: 9,
  userPartRefund: 10,
  paymentTimeout: 11
}

const reservationStatus = {
  booked: 0,
  arrived: 1,
  customerCancel: 2,
  branchCancel: 3,
  noShow: 4
}

export default {
  data () {
    return {
      memberStatus: memberStatus,
      ordersStatus: ordersStatus
    }
  },
  methods: {
    $_isMemberLocked (row) {
      switch (row.member_status) {
        case memberStatus.deleting:
        case memberStatus.deleted:
          return true
      }
      return false
    },
    $_isMemberStatusEnabled (status) {
      switch (status) {
        case memberStatus.disabled:
        case memberStatus.deleting:
        case memberStatus.deleted:
          return false
      }
      return true
    },
    $_isMemberEnabled (row) {
      return this.$_isMemberStatusEnabled(row.member_status)
    },
    $_getMemberButtonType (row) {
      switch (row.member_status) {
        case memberStatus.disabled:
          return 'danger'
        case memberStatus.deleting:
        case memberStatus.deleted:
          return 'info'
      }
      return ''
    },
    $_isOrdersFailed (status) {
      switch (status) {
        case ordersStatus.txnFailed:
        case ordersStatus.cancelled:
        case ordersStatus.release:
        case ordersStatus.fullRefund:
        case ordersStatus.partRefund:
        case ordersStatus.userFullRefund:
        case ordersStatus.userPartRefund:
        case ordersStatus.paymentTimeout:
          return true
      }
      return false
    },
    $_isReservationFailed (status) {
      switch (status) {
        case reservationStatus.customerCancel:
        case reservationStatus.branchCancel:
        case reservationStatus.noShow:
          return true
      }
      return false
    }
  }
}
